<div
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    class="order-details-container"
    [class]="{'isStoreChooserOpen': isStoreChooserOpen()}"
>
    <div class="order-details-header">
        @if(editingAddress || isStoreChooserOpen()){
            <button cdkFocusInitial class="button-undecorated back-icon-button" [attr.aria-label]="'Back to Order Details'"
            (click)="backToOrderDetails()">
                <cwo-icon [name]="iconName.arrow" class="back-icon"/>
            </button>
        }
        <span class="order-details-title">{{isStoreChooserOpen() ? ('modals.order_details_modal.store' | transloco) : orderDetailsModalTitle}}</span>
        <button class="button-undecorated" style="border-radius: 100%;" [attr.aria-label]="'Close Order Details Modal'"
            (click)="closeModal()">
            <cwo-round-icon [iconName]="iconName.close" [size]="'medium'" />
        </button>
    </div>
    @if(showPrompt()) {
        <p class="order-details-message">
            {{orderDetailsModalMessageFromItem}}
        </p>
    }

    @if(!!editingAddress){
        <div class="edit-address-container" [ngClass]="{'expanded': expanded}">
            <cwo-edit-address 
                [address]="editingAddress" 
                (closeEdit)="backToOrderDetails()" 
                (deliveryInstructionExpanded)="handleDeliveryInstructionExpanded($event)" 
                [isSavedAddress]="isSavedAddress"
                [orderType]="editingOrderType"
            />
        </div>
    }
    @if(isOrderEditorOpen() && showOrderCreationForm){
        <div class="order-details-content" [ngClass]="{'hidden' : !!editingAddress}" >
            <cwo-order-creation-form #orderCreationForm (successfullyCreated)="handleSuccess(false)" (editAddress)="editAddress($event)" [storeStatusValue]="storeStatus" (storeStatusChanged)="storeStatusChange($event)"/>
        </div>

        @if (!editingAddress) {
            <div class="button-container">
                <button cwoAsyncButton [subscription]="orderCreationFormCompRef()?.loadingSubscription!" class="button-accent done-button" (click)="onSubmit()">{{'modals.order_details_modal.done' | transloco}}</button>
            </div>
        }
    } @else if(isStoreChooserOpen() && !embedded()) {
        <cwo-store-chooser />
    } @else {
        <cwo-order-details-information [ngStyle]="{'width': '100%', 'display': 'flex'}"
            [store]="configState().store ?? undefined" 
            [orderType]="orderTypeName()"
            [address]="this.orderService.order().customer?.address?.street" [schedule]="schedule()"
            [deferDate]="stateOrderDeferTime()">
        </cwo-order-details-information>
    }
</div>